import { render, staticRenderFns } from "./MinHeight.vue?vue&type=template&id=51c7433e&"
import script from "./MinHeight.vue?vue&type=script&lang=js&"
export * from "./MinHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports